export default "__VITE_ASSET__B1E0n7WJ__"